// import { useMutation, useQueryClient } from '@tanstack/react-query';
// import { sellerServices } from '../services/seller.service';
// import { toast } from 'react-hot-toast';



// const parseApiError = (error) => {
//   const message =
//     error?.response?.data?.error ||
//     error?.response?.data?.message ||
//     error?.message ||
//     'Something went wrong';

//   return new Error(message);
// };


// export const useUpsertKycDocument = (sellerId) => {
//   const queryClient = useQueryClient();

//   return useMutation({
//     mutationFn: ({ documentId, payload }) =>
//       sellerServices.upsertKycDocument(sellerId, documentId, payload),
//     onSuccess: () => {
//       queryClient.invalidateQueries({ queryKey: ['seller', sellerId] });
//     },
//      onError: (error) => {

//         console.log('5. ON ERROR FIRED:', error);

//       toast.error(error?.error || 'Failed to update seller profile');
//     },
//   });
// };

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sellerServices } from '../services/seller.service';
import { toast } from 'react-hot-toast';

const parseApiError = (error) => {
  const message =
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.message ||
    'Something went wrong';

  return new Error(message);
};

export const useUpsertKycDocument = (sellerId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ documentId, payload }) => {
      try {
        return await sellerServices.upsertKycDocument(
          sellerId,
          documentId,
          payload
        );
      } catch (error) {
        console.log(
          '1. AXIOS ERROR:',
          error?.response?.data || error
        );

        throw parseApiError(error);
      }
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['seller', sellerId],
      });

      toast.success('KYC document updated successfully');
    },

    onError: (error) => {
      console.log('2. ON ERROR FIRED:', error);

      toast.error(
        error?.message || 'Failed to update KYC document'
      );
    },
  });
};